import React from "react";

const OrderPageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75906 3.64844C5.28906 3.64844 3.28906 5.65844 3.28906 8.11844V17.5284C3.28906 19.9884 5.29906 21.9984 7.75906 21.9984H16.2291C18.6991 21.9984 20.6991 19.9884 20.6991 17.5284V8.11844C20.7091 5.64844 18.6991 3.64844 16.2391 3.64844H7.75906Z"
        fill="#3D68FF"
      />
      <path
        d="M9.64977 2C8.60977 2 7.75977 2.84 7.75977 3.88V4.82C7.75977 5.86 8.59977 6.7 9.63977 6.7H14.3498C15.3898 6.7 16.2298 5.86 16.2298 4.82V3.88C16.2398 2.84 15.3898 2 14.3498 2H9.64977Z"
        fill="#3055D4"
      />
      <path
        d="M8 12.9492C7.59 12.9492 7.25 12.6092 7.25 12.1992C7.25 11.7892 7.59 11.4492 8 11.4492H15C15.41 11.4492 15.75 11.7892 15.75 12.1992C15.75 12.6092 15.41 12.9492 15 12.9492H8Z"
        fill="white"
      />
      <path
        d="M8 16.9492C7.59 16.9492 7.25 16.6092 7.25 16.1992C7.25 15.7892 7.59 15.4492 8 15.4492H12.38C12.79 15.4492 13.13 15.7892 13.13 16.1992C13.13 16.6092 12.79 16.9492 12.38 16.9492H8Z"
        fill="white"
      />
    </svg>
  );
};

export default OrderPageIcon;
